import React, { useState, useEffect } from "react";

import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import SubsiteService from "../../services/subsite.service";
import UserService from "../../services/user.service";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import { useDispatch, useSelector } from "react-redux";
import { Container, Row, Col } from "react-bootstrap";
import { getUser, updateEmailPrefs } from '../../reducers/auth';

const AdminCommunication = () => {
  const [value, setValue] = useState('');
  const { isAdmin, isSuperAdmin, loading } = useSelector(state => state.auth);
  const currentUser = useSelector(getUser);
  const dispatch = useDispatch();

  useEffect(() => {
    async function fetchData() {
      var content = await SubsiteService.getHomepageContent();
      console.log("CONTENT", content);
      setValue(content);
    }
    fetchData();   
  }, []);

  const handleAllEmailUpdate = async (evt) => {
    var emailPrefs = currentUser.email_pref;

    if(!emailPrefs) {
        emailPrefs = {"allEmails": false, "poEmails" : false, "dailyEmails": false};
    }

    UserService.setEmailPrefs({"allEmails": evt.target.checked, "poEmails" : emailPrefs.poEmails, "dailyEmails": emailPrefs.dailyEmails});
    dispatch(updateEmailPrefs({"allEmails": evt.target.checked, "poEmails" : emailPrefs.poEmails, "dailyEmails": emailPrefs.dailyEmails}));
  }

  const handleDailyEmailUpdate = async (evt) => {
    var emailPrefs = currentUser.email_pref;

    if(!emailPrefs) {
        emailPrefs = {"allEmails": false, "poEmails" : false, "dailyEmails": false};
    }

    UserService.setEmailPrefs({"allEmails": emailPrefs.allEmails, "poEmails" : emailPrefs.poEmails, "dailyEmails": evt.target.checked });
    dispatch(updateEmailPrefs({"allEmails": emailPrefs.allEmails, "poEmails" : emailPrefs.poEmails, "dailyEmails": evt.target.checked }));
  }
  
  const handlePOEmailUpdate = async (evt) => {
    var emailPrefs = currentUser.email_pref;

    if(!emailPrefs) {
        emailPrefs = {"allEmails": false, "poEmails" : false, "dailyEmails": false};
    }

    UserService.setEmailPrefs({"allEmails": emailPrefs.allEmails, "poEmails" : evt.target.checked, "dailyEmails": emailPrefs.dailyEmails});
    dispatch(updateEmailPrefs({"allEmails": emailPrefs.allEmails, "poEmails" : evt.target.checked, "dailyEmails": emailPrefs.dailyEmails}));
  }
  
  return (
    
    <div className="user-details-container">
        <h2>Communication Preferences</h2>
        <Container  className="user-data">
            <Row>
                <Col className="title">
                <Form.Check
                    type="checkbox"
                    id="allemails"
                    label="Recieve All Order Emails"
                    checked={currentUser?.email_pref?.allEmails || false}
                    onChange={handleAllEmailUpdate}
                />
                </Col>
            </Row>
            <Row>
                <Col className="title">
                <Form.Check
                    type="checkbox"
                    id="dailyemails"
                    label="Recieve A Daily Summary of Orders"
                    checked={currentUser?.email_pref?.dailyEmails || false}
                    onChange={handleDailyEmailUpdate}
                />
                </Col>
            </Row>
            {isSuperAdmin && 
            <Row>
                <Col className="title">
                    <Form.Check // prettier-ignore
                        type="checkbox"
                        id="poexcel"
                        label="Recieve PO Excel"
                        checked={currentUser?.email_pref?.poEmails || false}
                        onChange={handlePOEmailUpdate}
                    />
                </Col>
            </Row>
            }
        </Container>
    </div>
  );
};
export default AdminCommunication;